
import { Button } from "@/components/ui/button"

type SubmitButtonProps = {
  loading: boolean
  adminCreating?: boolean
}

export function SubmitButton({ loading, adminCreating = false }: SubmitButtonProps) {
  return (
    <Button type="submit" className="w-full" disabled={loading}>
      {loading 
        ? "Processando..." 
        : adminCreating 
          ? "Criar Usuário" 
          : "Cadastrar"
      }
    </Button>
  )
}
